<template>
  <MultiRadio
    v-model="squadSize"
    v-validate="'required'"
    :disabled="isTournamentFieldDisabled('squad_size')"
    name="squadSize"
    :label="$$t('Squad size:', 'squad-size_label')"
    :items="squadsItems"
    :error="errors.first('squadSize')"
    :cols-auto="false"
    custom-class="mb-0"
    required
    class="col-12"
  />
</template>

<script>
const squadsItemsDefault = { '1': '1v1' };
import { mapGetters, mapMutations } from 'vuex';
import MultiRadio from '@/components/molecules/form/MultiRadio';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentSquadSizeSetting',
  inject: ['$validator'],
  components: {
    MultiRadio,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    ...mapGetters([
      'currentTournament',
      'isTournamentFieldDisabled',
      'getGamePropById',
    ]),
    squadSize: {
      get() {
        return this.$lodash
          .get(this.currentTournament, 'players_config.squad_size', '')
          .toString();
      },
      set(newVal) {
        this.errors.remove('squadSize');
        this.updateCurrentTournament({
          squad_size: +newVal,
          component: 'players_config',
        });
      },
    },
    squadsItems() {
      const game = this.$lodash.get(this.currentTournament, 'info.game', false);
      const squads = game
        ? this.getGamePropById(this.currentTournament.info.game, 'squads')
        : null;
      return squads
        ? squads.reduce((result, item) => {
            result[item] =
              item !== 1 ? `${item}v${item}` : this.$$t('Solo', 'squads-1v1');
            return result;
          }, {})
        : squadsItemsDefault;
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
